import React from "react";
import styled from "styled-components";
import { Grid, Tooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

const Label = styled.div`
  font-size:17px;
  font-weight:bold;
  color: rgb(51,51,51)
  min-width:200px;
`;
const LB_BLUE = "#2196f3";

const LabelGrid = styled(Grid)`
  && {
    width: 200px;
  }
`;
const FormGrid = styled(Grid)`
  min-height:40px;
`;
const StyledGrid = styled(Grid)`
  border-bottom: ${props => (props.hasBorder ? "1px solid gainsboro" : "")}
`;
const LateralField = ({ label, children, hasBorder, tooltip }) => (
  <StyledGrid hasBorder={hasBorder} container item alignItems="center" justify="flex-start">
    {<LabelGrid container item alignItems="flex-start">
      <Label>{label}</Label>
      {tooltip && <Tooltip title={tooltip || ""} placement={"top"}><span style={{ color: LB_BLUE }}><InfoIcon /></span></Tooltip>}
     </LabelGrid>}
    <FormGrid container item xs={7} alignItems="center">{children}</FormGrid>
  </StyledGrid>
);

export default LateralField;
